import { useTranslation } from "react-i18next";
import { getLocalizedPageTitle } from "../resources/resourceRegistry";

const PageNav = ({ prevPage, nextPage, onSelect }) => {
  const { i18n, t } = useTranslation();
  const isRtl = i18n.dir() === "rtl";

  return (
    <div className="page-nav">
      {prevPage ? (
        <button
          type="button"
          onClick={() => {
            onSelect(prevPage.slug);
          }}
          className="page-nav-link page-nav-button"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="18"
            height="18"
            style={{
              marginInlineEnd: 8,
              transform: isRtl ? "scaleX(-1)" : "none",
            }}
            aria-hidden="true"
            focusable="false"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.7071 4.29289C12.0976 4.68342 12.0976 5.31658 11.7071 5.70711L6.41421 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H6.41421L11.7071 18.2929C12.0976 18.6834 12.0976 19.3166 11.7071 19.7071C11.3166 20.0976 10.6834 20.0976 10.2929 19.7071L3.29289 12.7071C3.10536 12.5196 3 12.2652 3 12C3 11.7348 3.10536 11.4804 3.29289 11.2929L10.2929 4.29289C10.6834 3.90237 11.3166 3.90237 11.7071 4.29289Z"
              fill="currentColor"
            />
          </svg>
          <span>{getLocalizedPageTitle(prevPage, t)}</span>
        </button>
      ) : (
        <span />
      )}

      {nextPage ? (
        <button
          type="button"
          onClick={() => {
            onSelect(nextPage.slug);
          }}
          className="page-nav-link page-nav-button"
        >
          <span>{getLocalizedPageTitle(nextPage, t)}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="18"
            height="18"
            style={{
              marginInlineStart: 8,
              transform: isRtl ? "scaleX(-1)" : "none",
            }}
            aria-hidden="true"
            focusable="false"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.2929 4.29289C12.6834 3.90237 13.3166 3.90237 13.7071 4.29289L20.7071 11.2929C21.0976 11.6834 21.0976 12.3166 20.7071 12.7071L13.7071 19.7071C13.3166 20.0976 12.6834 20.0976 12.2929 19.7071C11.9024 19.3166 11.9024 18.6834 12.2929 18.2929L17.5858 13H4C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11H17.5858L12.2929 5.70711C11.9024 5.31658 11.9024 4.68342 12.2929 4.29289Z"
              fill="currentColor"
            />
          </svg>
        </button>
      ) : (
        <span />
      )}
    </div>
  );
};

export default PageNav;
